module.exports = "/packs/attend-e8acbfa32fe8092b82131256656ce773.svg";